import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { Pagination } from "antd";
import { getPendingRewardList } from "../../../../../redux/employeereward/employeeRewardState";
import NominationCard from "../../hyvid-rewards/components/NominationCard";

const ApprovalList = ({
  recordList, 
  pagination, 
  filters, 
  doSearch
}) => {

  useEffect(() => {
    doSearch({ paginate: pagination?.per_page || 10 });
  }, [doSearch, pagination?.per_page]);

  return (
    <HeaderComponent
      title="For Your Review"
      titleClass="text-[16px] font-medium"
      description="Client-submitted nominations waiting for your approval"
      descriptionClass="text-sm muted-text"
      cardBorder="border"
    >
      <div className="max-h-[600px] overflow-y-auto pr-2">
        <NominationCard
          recordList={recordList} 
        />

        {pagination?.total > pagination?.per_page && (
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination?.current_page}
              pageSize={pagination?.per_page}
              total={pagination?.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination?.per_page,
                })
              }
            />
          </div>
        )}
      </div>
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeReward.pendingRewardList?.items,
  pagination: state.employeeReward.pendingRewardList?.pagination,
  requesting: state.employeeReward.pendingRewardList?.requesting,
  filters: state.employeeReward.pendingRewardList?.filters,
  error: state.employeeReward.pendingRewardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getPendingRewardList(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalList);